import React from 'react';
import { Layout } from '@/components/Layout';
import { Send, CheckCircle, Mail, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Submission() {
  const categories = [
    { title: '自媒体起号', content: '自媒体 0 到 1 起号教程' },
    { title: '短视频剪辑', content: '短视频拍摄、剪辑、运镜、封面设计教程' },
    { title: '文案创作', content: '文案写作、爆款标题、脚本模板' },
    { title: '运营推广', content: '运营涨粉、流量解析、投流技巧' },
    { title: '商业化变现', content: '变现商业化、私域搭建、项目拆解' },
    { title: 'AI 实战', content: 'AI 自媒体实战、AI 工具使用指南' },
    { title: '教学干货', content: '教学类资源、学习资料、干货总结' },
  ];

  return (
    <Layout>
      <div className="container mx-auto px-4 md:px-6 py-12 max-w-4xl">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="bg-primary/10 p-4 rounded-2xl mb-4 text-primary">
            <Send className="h-8 w-8" />
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight mb-4">教程投送</h1>
          <p className="text-muted-foreground text-lg max-w-xl">
            欢迎向万象聚聚官 2135C 投递高质量自媒体教程、干货指南、实战教程与学习资源。
          </p>
        </div>

        <div className="space-y-12">
          {/* Categories Section */}
          <section className="bg-card border rounded-3xl p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-8">
              <CheckCircle className="h-6 w-6 text-green-500" />
              <h2 className="text-2xl font-bold">投送范围</h2>
            </div>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
              {categories.map((cat, idx) => (
                <div key={idx} className="p-4 bg-muted/30 rounded-2xl border border-border/50 hover:border-primary/30 transition-colors">
                  <h3 className="font-bold text-sm mb-1 text-primary">{cat.title}</h3>
                  <p className="text-xs text-muted-foreground">{cat.content}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Requirements Section */}
          <section className="grid md:grid-cols-2 gap-8">
            <div className="bg-card border rounded-3xl p-8 shadow-sm">
              <div className="flex items-center gap-3 mb-6">
                <HelpCircle className="h-6 w-6 text-orange-500" />
                <h2 className="text-2xl font-bold">投送要求</h2>
              </div>
              <ul className="space-y-3 text-sm text-muted-foreground">
                <li className="flex gap-2">
                  <span className="h-1.5 w-1.5 bg-primary rounded-full mt-1.5 shrink-0" />
                  <span>内容原创、高质量、无侵权</span>
                </li>
                <li className="flex gap-2">
                  <span className="h-1.5 w-1.5 bg-primary rounded-full mt-1.5 shrink-0" />
                  <span>教程需清晰、可学习、有价值</span>
                </li>
                <li className="flex gap-2">
                  <span className="h-1.5 w-1.5 bg-primary rounded-full mt-1.5 shrink-0" />
                  <span>不涉及违规、低俗、敏感内容</span>
                </li>
                <li className="flex gap-2">
                  <span className="h-1.5 w-1.5 bg-primary rounded-full mt-1.5 shrink-0" />
                  <span>提供完整介绍（用途、适用人群、价值点）</span>
                </li>
              </ul>
            </div>

            {/* Submission Method */}
            <div className="bg-primary/5 border border-primary/20 rounded-3xl p-8 flex flex-col justify-center items-center text-center">
              <div className="bg-primary text-primary-foreground p-4 rounded-full mb-6">
                <Mail className="h-8 w-8" />
              </div>
              <h2 className="text-2xl font-bold mb-4">投稿方式</h2>
              <p className="text-sm text-muted-foreground mb-6">
                请将资源发送至邮箱，邮件主题请写：<br />
                <span className="font-bold text-foreground">教程投送 + 作品名称</span>
              </p>
              <div className="p-3 bg-background border rounded-xl font-mono text-primary font-bold mb-6">
                3894663764@qq.com
              </div>
              <p className="text-xs text-muted-foreground italic">
                我们将在 3 个工作日内完成审核并回复。
              </p>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
}
